<script setup>
import LoadingSpinnerIcon from 'assets/loader/loading-spinner.svg'
</script>

<template>
    <span>
        <LoadingSpinnerIcon />
    </span>
</template>

<style lang="scss">
.fullscreen-loader {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: fixed;
    inset: 0;
    z-index: z('fullscreen-loader');
    height: 100vh;
}

.container-loader {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: absolute;
    inset: 0;
    z-index: z('container-loader');

    svg {
       transform: scale(2.5);
    }
}

.form-loader {
    position: absolute;
    inset: 2px;
    display: flex;
    align-items: center;
    padding: 0 0 0 20px;
    border-radius: 10px;
}

.spinner1 {
    animation: spinner .8s linear infinite
}

.spinner2 {
    animation-delay: -.65s
}

.spinner3 {
    animation-delay: -.5s
}

@keyframes spinner {
    93.75%, 100% {
        r: 3px
    }

    46.875% {
        r: .2px
    }
}
</style>
